// hooks/useUserInventory.js
import { useState, useEffect } from "react";
import { db } from "../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useDistributor } from "./useDistributor"; // Assuming this hook fetches the current distributor/user.

const useUserInventory = () => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = useDistributor(); // Get the current distributor/user

  useEffect(() => {
    if (!user) return; // Prevent fetching if user is not available

    const fetchInventory = async () => {
      try {
        const inventoryCollection = collection(db, "all-products");
        const inventorySnapshot = await getDocs(inventoryCollection);
        const inventoryList = inventorySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Filter inventory items where the retailerOrDistributorId matches the current user's UID
        const userInventory = inventoryList.filter(
          (item) => item.retailerOrDistributorId === user.uid
        );

        setInventory(userInventory);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInventory();
  }, [user]);

  return { inventory, loading, error };
};

export default useUserInventory;
